import $ from 'jquery';
import lazyframe from 'lazyframe';
import 'slick-carousel/slick/slick';
import MicroModal from 'micromodal';
import Parallax from 'parallax-js';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayJS from 'dayjs';
import { func } from 'prop-types';
import { BREAKPOINTS } from '@/scripts/helpers/constants';
import { accordion } from '../../../source/modules/containers/accordion/index';
import '../../../source/scripts/scrollUp.js';
import { lazyLoadJavascripts } from '../../../source/scripts/helpers/lazy';
import { footer } from '../../../source/modules/sections/footer/index';

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false,
  });

  parallaxInstance.friction(0.2, 0.2);
};

$('.js-scroll-to-uploader').on('click', () => {
  const target = $('.uploader-wrapper');

  if (target.length) {
    // Only prevent default if animation is actually gonna happen
    $('html, body').animate({
      scrollTop: target.offset().top + 20,
    }, 1000, () => {
      // Callback after animation
      // Must change focus!
      const $target = $(target);
      $target.focus();
      if ($target.is(':focus')) { // Checking if the target was focused
        return false;
      }
      $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
      $target.focus(); // Set focus again
    });
  }
});

window.addEventListener("load", (event) => {
  if ($(window).width() > 768) {
    const scene = $('.decorations-wrapper');
    $(scene).each(function () {
      initParallaxDecorations($(this));
    });
    const scene2 = $('.decorations-wrapper-c2a');

    scene2.each(function () {
      initParallaxDecorations($(this));
    });
  }
});
const modalLoaderId = 'modal-loader';

const startLoad = () => {
  const modal = $(`#${modalLoaderId}`);
  const renderLoaderMarkup = () => (`
      <div class="modal modal--loader" id=${modalLoaderId} aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close="data-micromodal-close">
          <div class="loader">
            <div class="loader__indicator">
              <div class="circle-loader">
                <div class="circle-left">
                  <div class="loader-inner"></div>  
                </div>
                <div class="circle-right">
                  <div class="loader-inner"></div>
                </div>
                <span></span>
              </div>
            </div>
            <div class="loader__text">Loading, please wait...</div>
          </div>
        </div>
      </div>
    `
  );

  if (!modal.length) {
    $('body').append(renderLoaderMarkup());
  }

  MicroModal.show(modalLoaderId);
};

const finishLoad = () => {
  const modal = $(`#${modalLoaderId}`);

  if (modal.length) modal.remove();
};

const VISIBLE = 'is-visible';

export const scrollToMiddle = (id) => {
  const element = $(id);

  if (element.length) {
    const elemPosition = $(id).offset().top;
    const elemHeight = $(id).height();
    const windowHeight = $(window).height();
    const scrollPos = elemPosition + elemHeight / 2 - windowHeight / 2;

    $('html, body').animate(
      {
        scrollTop: scrollPos,
      },
      400,
      'swing',
    );
  }
};

function readMore() {
  const wrapper = $('.js-read-more-wrapper');

  wrapper.each(function () {
    const currentWrapper = $(this);
    const button = currentWrapper.find('.js-read-more-button');

    button.click(() => {
      const SCROLL_DURATION = 400;

      if (currentWrapper.hasClass(VISIBLE)) {
        scrollToMiddle(currentWrapper);
        setTimeout(() => {
          currentWrapper.removeClass(VISIBLE);
        }, SCROLL_DURATION);
      } else {
        currentWrapper.addClass(VISIBLE);
      }
    });
  });
}

const initReviewsSlider = () => {
  const selector = $('.js-reviews-slider');

  if (selector.length) {
    selector.not('.slick-initialized').slick({
      arrows: true,
      mobileFirst: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1160,
          settings: {
            variableWidth: false,
            slidesToShow: 3,
          },
        },
      ],
    }).on('setPosition swipe', (event, slick) => {
      slick.$slides.css('height', `${slick.$slideTrack.height()}px`);
    });
  }
};

const initRelatedContentSlider = () => {
  const selector = $('.js-related-content-slider');

  if (selector.length) {
    selector.not('.slick-initialized').slick({
      arrows: true,
      mobileFirst: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      infinite: true,
      variableWidth: false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1160,
          settings: {
            variableWidth: false,
            slidesToShow: 3,
          },
        },
      ],
    }).on('setPosition swipe', (event, slick) => {
      if ($(window).width() >= 768) {
        slick.$slides.css('height', `${slick.$slideTrack.height()}px`);
      }
    });
  }
};
const initReasonsToChooseSlider = () => {
  const selector = $('.js-reasons-to-choose-slider');

  if (selector.length) {
    selector.not('.slick-initialized').slick({
      arrows: true,
      mobileFirst: true,
      slidesToShow: 1,
      adaptiveHeight: true,
      variableWidth: false,
      infinite: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1160,
          settings: {
            variableWidth: false,
            slidesToShow: 3,
          },
        },
      ],
    }).on('setPosition swipe', (event, slick) => {
      slick.$slides.css('height', `${slick.$slideTrack.height()}px`);
    });
  }
};

$(() => {
  const rating = $('.js-rating');
  const ratingStars = rating.find('.star');

  const handleHoverStar = function () {
    const index = $(this).index();
    for (let i = 0; i <= index; i += 1) {
      $(ratingStars[i]).addClass('active');
    }
  };

  const handleBlurStar = function () {
    ratingStars.removeClass('active');
  };

  const handleClickStar = function () {
    const index = $(this).index();
    ratingStars.removeClass('star--half star--full').addClass('star--empty');

    for (let i = 0; i <= index; i += 1) {
      $(ratingStars[i]).removeClass('star--empty').addClass('star--full');
    }

    localStorage.setItem('rating-star', index + 1);
  };

  ratingStars.hover(handleHoverStar, handleBlurStar);
  ratingStars.click(handleClickStar);
});

function videoLazyframe() {
  const elements = $('.video-player__lazyframe');

  lazyframe(elements, {
    onAppend: iframe => {
      $(iframe).attr('allow', 'autoplay');
    },
  });
}

// table of contents helper
(() => {
  const container = $('.table-of-contents');
  const itemsAmount = container.find('.link-styled').length;
  const section = $('.page-section--contents-with-reviews');

  if ($(window).width() >= 1160 && itemsAmount >= 8) {
    container.addClass('is-expanded');
  } else if ($(window).width() >= 1160 && itemsAmount && itemsAmount < 8) {
    section.removeClass('is-fullwidth-rating');
    container.removeClass('is-expanded');
  } else if ($(window).width() >= 1160 && !itemsAmount) {
    section.addClass('is-fullwidth-rating');
  } else {
    container.removeClass('is-expanded');
  }
})();

(() => {
  $('#form-preview-description-trigger').on('click', function () {
    $(this).toggleClass('is-active');
    $('#form-preview-description').slideToggle(100);
  });
})();

const setSmoothAnchorsScroll = () => {
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        && location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        let target = $(this.hash);
        target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top,
          }, 1000, () => {
            // Callback after animation
            // Must change focus!
            const $target = $(target);
            $target.focus();
            if ($target.is(':focus')) { // Checking if the target was focused
              return false;
            }
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          });
        }
      }
    });
};

// $(window).on('load resize', () => {
// });

initReasonsToChooseSlider();
initRelatedContentSlider();
initReviewsSlider();
accordion();
readMore();

videoLazyframe();

// actions counters
(() => {
  $.fn.animateNumbers = function (stop, separator, duration, ease) {
    return this.each(function () {
      const $this = $(this);
      const isInput = $this.is('input');
      // eslint-disable-next-line radix
      const start = parseInt(
        isInput ? $this.val().replace(/ /g, '') : $this.text().replace(/ /g, ''),
      );
      const regex = /(\d)(?=(\d\d\d)+(?!\d))/g;
      // eslint-disable-next-line no-param-reassign
      separator = separator === undefined ? true : separator;

      // number inputs can't have separator or it blanks out
      if (isInput && $this[0].type === 'number') {
        // eslint-disable-next-line no-param-reassign
        separator = false;
      }

      $({ value: start }).animate(
        { value: stop },
        {
          duration: duration === undefined ? 1000 : duration,
          easing: ease === undefined ? 'swing' : ease,
          step() {
            isInput
              ? $this.val(Math.floor(this.value))
              : $this.text(Math.floor(this.value));
            if (separator) {
              isInput
                ? $this.val($this.val().replace(regex, '$1 '))
                : $this.text($this.text().replace(regex, '$1 '));
            }
          },
          complete() {
            if (
              // eslint-disable-next-line radix
              parseInt($this.text()) !== stop
              // eslint-disable-next-line radix
              || parseInt($this.val()) !== stop
            ) {
              isInput ? $this.val(stop) : $this.text(stop);
              if (separator) {
                isInput
                  ? $this.val($this.val().replace(regex, '$1 '))
                  : $this.text($this.text().replace(regex, '$1 '));
              }
            }
          },
        },
      );
    });
  };

  dayJS.extend(advancedFormat);

  const initCurrentDate = () => {
    const counterInitBlock = $('#action-counters-current-date');
    const dayFormat = 'MMM Do, YYYY';

    counterInitBlock.text(`Today ${dayJS().format(dayFormat)}`);
  };
  initCurrentDate();

  const dailyMax = {
    0: { edits: 35534, sends: 3198, signs: 4264 },
    1: { edits: 72780, sends: 6550, signs: 8734 },
    2: { edits: 75381, sends: 6784, signs: 9046 },
    3: { edits: 73503, sends: 6615, signs: 8820 },
    4: { edits: 70816, sends: 6373, signs: 8498 },
    5: { edits: 59903, sends: 5391, signs: 7188 },
    6: { edits: 31872, sends: 2868, signs: 3825 },
  };

  const getValueForNow = maxValue => {
    // w1 - длительность утреннего подъема
    // w2 - длительность вечернего спада
    // t1 - время утреннего подъема
    // t2 - время вечернего спада

    const consts = {
      0: {
        w1: 150, w2: 240, t1: 420, t2: 1320,
      },
      1: {
        w1: 150, w2: 250, t1: 420, t2: 1080,
      },
      2: {
        w1: 150, w2: 250, t1: 420, t2: 1080,
      },
      3: {
        w1: 150, w2: 250, t1: 420, t2: 1080,
      },
      4: {
        w1: 150, w2: 250, t1: 420, t2: 1080,
      },
      5: {
        w1: 150, w2: 180, t1: 420, t2: 960,
      },
      6: {
        w1: 150, w2: 250, t1: 420, t2: 1060,
      },
    };
    const BOSTON_HOURS_OFFSET = -4;
    const PERCENT_GROWTH_PER_YEAR = 20;
    const today = new Date();
    const todayDay = today.getDay();
    const fullYear = today.getFullYear();
    const fullHours = today.getHours();
    const fullMinutes = today.getMinutes();
    const fullSeconds = today.getSeconds();
    const hoursZeroOffset = today.getTimezoneOffset() / 60;
    const {
      w1, w2, t1, t2,
    } = consts[todayDay];

    const hoursZoneCorrection = hours => (hours > 0 ? (hours < 24 ? hours : hours - 24) : 24 - hours);
    const yearlyGrowingCorrection = year => ((year - 2019) * PERCENT_GROWTH_PER_YEAR) / 100 + 1;
    const correctedHours = hoursZoneCorrection(
      fullHours + hoursZeroOffset + BOSTON_HOURS_OFFSET,
    );
    const totalSecondsFromMidnight = correctedHours * 3600 + fullMinutes * 60 + fullSeconds;

    // const getValueByDate = x => 2.7**(-((x-1)**2)/0.2);
    const getValueByDate = ({
      // eslint-disable-next-line no-shadow
      curMinute, maxValue, w1, w2, t1, t2,
    }) => {
      const minRate = Math.round(maxValue / (4 * 1440));
      const baseRate = (maxValue - minRate * 1440) / 600;
      return (
        minRate * curMinute
        + (baseRate / 2)
        * (w1 * Math.log(Math.abs(Math.cosh((curMinute - t1) / w1)))
          - w1 * Math.log(Math.abs(Math.cosh(-t1 / w1)))
          - w2 * Math.log(Math.abs(Math.cosh((curMinute - t2) / w2)))
          + w2 * Math.log(Math.abs(Math.cosh(-t2 / w2))))
      );
    };

    // const currentValue = Math.floor(getValueByDate(totalSecondsFromMidnight/86400)*maxValue);
    return Math.floor(
      getValueByDate({
        curMinute: totalSecondsFromMidnight / 60,
        maxValue,
        w1,
        w2,
        t1,
        t2,
      }),
    );
  };

  const todayDay = new Date().getDay();
  const todayData = dailyMax[todayDay];
  const randomUpdate = successPercentage => !!(Math.random() < successPercentage / 100);

  // initial insert
  $('#counter-uploaded').animateNumbers(
    getValueForNow(todayData.edits),
    true,
    1500,
  );
  $('#counter-saved').animateNumbers(
    getValueForNow(todayData.signs),
    true,
    1150,
  );
  $('#counter-edited').animateNumbers(getValueForNow(todayData.sends), true, 750);

  // random update
  setInterval(() => {
    if (randomUpdate(30)) {
      $('#counter-uploaded').animateNumbers(getValueForNow(todayData.edits), 250);
    }
  }, 1000);

  setInterval(() => {
    if (randomUpdate(30)) {
      $('#counter-saved').animateNumbers(getValueForNow(todayData.signs), 250);
    }
  }, 1000);

  setInterval(() => {
    if (randomUpdate(30)) {
      $('#counter-edited').animateNumbers(getValueForNow(todayData.sends), 250);
    }
  }, 1000);
})();

footer();

setSmoothAnchorsScroll();

window.$ = $;
window.startLoad = startLoad;
window.finishLoad = finishLoad;
window.lazyLoadJavascripts = lazyLoadJavascripts;
